import React, {
  ChangeEvent,
  DragEvent,
  FC,
  useEffect,
  useRef,
  useState,
} from "react";
import { THUMBNAIL_SOURCE } from "../../config/constants";
import { useTranslate } from "@tolgee/react";
import { useDispatch, useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../pages/lomavisCreator";
import toast from "react-hot-toast";
import {
  addImageThumbnail,
  clearImageThumbnail,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MAIN_COLOR_CODES, PRIMARY_DARK } from "../../../../config/constants";
import { faCloudArrowUp } from "@fortawesome/pro-duotone-svg-icons";
import EditPreview from "./editPreview";
import VideoFrameSelector from "./selectThumbnail";
import { relocatePublishButtons } from "../../utils/uploadMediaFile";
import { Button } from "react-bootstrap";
import SuccessToast from "../../cards/toast";

interface MediaUploadAreaProps {
  platform: string;
  handleClose: Function;
  handleCloseNoConfirmation: Function;
}

const ThumbnailPicker: FC<MediaUploadAreaProps> = ({
  platform,
  handleClose,
  handleCloseNoConfirmation,
}) => {
  const { t } = useTranslate();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [mediaSource, setMediaSource] = useState<string | undefined>();
  const [rightMargin, setRightMargin] = useState(0);
  const dispatch = useDispatch();
  const footerRef = useRef(null);
  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );
  const thumbnailImage = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].uploadedImageThumbnail.url
  );
  const videoUrl = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].media[0].original_asset
  );

  const videoBlob = useSelector(
      (state: lomavisCreatorRootState) =>
          state.lomavisCreator.postData[platform].media[0].assetBlob
  );

  const source_media_uuid = useSelector(
      (state: lomavisCreatorRootState) =>
          state.lomavisCreator.postData[platform].media[0]?.source_media_uuid
  );

  const thumbnailStates = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.modalStates.thumbnail
  );

  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin,
    });
  }, []);

  const [dragIsOver, setDragIsOver] = useState(false);

  const [items, setItems] = useState([]);

  // Define the event handlers
  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();

    setDragIsOver(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragIsOver(false);
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragIsOver(false);

    const files = Array.from(event.dataTransfer.files);

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"]; // Define allowed file types
    const filteredFiles = files.filter((file) =>
      allowedTypes.includes(file?.type)
    );

    if (filteredFiles.length > 0) {
      handleUpload(filteredFiles[0]);
      filteredFiles.map((item) => {
        items.includes(item) ? "" : setItems([...items, item]);
      });
    } else {
      toast.error(`${t("errors.lomavisCreator.only_image_files")}`, {
        duration: 4000,
        position: "top-right",
      });
    }
  };

  const handleUploadClick = async () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  };

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }

    const fileList = e.target.files; // This is a FileList
    const fileArray = Array.from(fileList); // Convert the FileList to an array

    handleUpload(fileArray[0]);
  };

  const handleUpload = (filteredFile: any) => {
    let preview_image: any = URL.createObjectURL(filteredFile);

    const file_type = filteredFile.type;
    const fileSizeInBytes = filteredFile.size;

    dispatch(
      addImageThumbnail({
        url: preview_image,
        file: filteredFile,
        platform: platform,
      })
    );
  };
  const cancelEdits = () => {
    // dispatch(
    //   clearImageThumbnail({
    //     platform,
    //   })
    // );
    handleClose();
  };

  const [showToast, setShowToast] = useState(false);

  const triggerSuccessToast = () => {
    toast.success(t("lomavisCreator.image.saved"), {
      position: "top-right",
      id: "accounts.invites.table.invite_deleted",
    });
  };
  return (
    <div className="w-100 h-100 ">
      <SuccessToast show={showToast} onClose={() => setShowToast(false)} />
      {!thumbnailImage &&
        thumbnailStates.source === THUMBNAIL_SOURCE.UPLOAD_FILE && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "relative",
            }}
            onDragOver={handleDragOver}
            className="d-flex flex-column w-100 h-100 position-relative"
          >
            {
              <div className="bg-white rounded-2 p-6 w-100 h-100 ">
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onClick={() => handleUploadClick()}
                  className="w-100 h-100 d-flex flex-column justify-content-center justify-content-center p-6 rounded-2 border-secondary"
                  style={{
                    border: "2px dashed",

                    backgroundColor: dragIsOver && "rgba(0, 0, 0, 0.02)",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      textAlign: "center",
                      position: "relative",
                    }}
                    className="text-dark d-flex flex-column gap-3"
                  >
                    <i
                      className="fa-solid fa-cloud-arrow-up"
                      style={{
                        color: MAIN_COLOR_CODES[PRIMARY_DARK],
                        fontSize: "9rem",
                      }}
                    ></i>
                    <p
                      style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                      className="fs-1 fw-bold"
                    >
                      {t("creator.text.drop_file_here")}
                    </p>
                    {/* <p
                  style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                  className="fw-bolder"
                >
                  {t("creator.text.max_files")}
                </p> */}
                  </div>
                  <div
                    style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                    className="fs-3 text-center"
                  >
                    {t("or")}
                  </div>
                  <div
                    style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                    className="fs-3 fw-bold text-center"
                  >
                    {" "}
                    {t("lomavisCreator.thumbnail.uploadFromDevice")}
                  </div>
                  <input
                    type="file"
                    ref={inputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    multiple={true}
                    accept=".jpeg, .jpg, .png, .mp4"
                    max={2}
                  />
                </div>
              </div>
            }

            {/* <div
            ref={footerRef}
            style={{ bottom: "0", zIndex: 100, height: "60px" }}
            className="w-100 d-flex justify-content-end gap-3 align-items-center bg-white py-2 border-top rounded-3 "
          >
            <Button
              style={{ marginRight: rightMargin + "px" }}
              onClick={cancelEdits}
              variant="secondary"
              size="sm"
            >
              {t("lomavisCreator.cancel")}
            </Button>
          </div> */}
          </div>
        )}

      {thumbnailStates.source === THUMBNAIL_SOURCE.SELECT_VIDEO &&
        videoUrl &&
        !thumbnailImage && (
          <VideoFrameSelector
            setMediaSource={setMediaSource}
            videoUrl={
              source_media_uuid ? videoUrl : videoBlob ? videoBlob : videoUrl
            }
            platform={platform}
          />
        )}

      {thumbnailImage && (
        <div className="w-100 h-100">
          <EditPreview
            handleClose={handleClose}
            handleCloseNoConfirmation={handleCloseNoConfirmation}
            platform={platform}
            videoUrl={
                source_media_uuid ? videoUrl : videoBlob ? videoBlob : videoUrl
            }
            successNotification={() => triggerSuccessToast()}
          />
        </div>
      )}
    </div>
  );
};

export default ThumbnailPicker;
